module.exports = __webpack_public_path__ + "img/bar-chart.cc78e55b.svg";